export class SearchGroupModel {

    public id                   : string = '';
    public type                 : number = 0;
    public displayName          : string = "";
    public longName             : string = "";
    public isDefault            : boolean = false;
    public shouldAutoSearch     : boolean = false;
    public includesAutoComplete : boolean = false;
    public isSelected           : boolean = false;

    /**
     * Construct an instance of the search group model for use by the search bar
     * @param id The ID of the field to use,should match the property on the search param
     * @param type The type of input field to use, defined in SearchByType 
     * @param display The text that appears in the dropdown
     * @param long The text that appears above the input, or in the input for static input
     * @param isDefault Whether it should be selected on load
     * @param shouldAutoSearch When this input is selected, should it trigger search automatically
     * @param isAutocomplete Is it an autocomplete input field
     * @param isSelect Is it a select input field
     */
    constructor(id: string, type:number, display: string, long: string, isDefault: boolean, 
                shouldAutoSearch?: boolean, isAutocomplete?:boolean, isSelect?:boolean){
        this.id = id;
        this.type = type;
        this.displayName = display;
        this.longName = long;
        this.isDefault = isDefault;
        this.shouldAutoSearch = shouldAutoSearch ? shouldAutoSearch : false;
        this.includesAutoComplete = isAutocomplete ? isAutocomplete : false
        this.isSelected = isSelect ? isSelect : false;
    }

}